export default __webpack_public_path__ + "660c3ea3ce6ed49a5a5c356aa7938a99.svg";